import { useState } from "react";
import { Button } from "react-bootstrap";
import { toast } from "react-toastify";
import { defineValueInInput } from "../../../components/funcForInput";
import { ApiEndpoints, reqPatch, reqPostDownloadFile } from "../../../config/apiClient";

export default function ArquivoViewComunicado({ view, comunicado, documentos, handleUpdate }: iProps) {
    const [loading, setLoading] = useState<boolean>(false);

    async function handleApagarArquivo(view: "imagem" | "documento") {
        let mensagem = `Tem certeza que deseja apagar a imagem?`;
        if (view === "documento") {
            mensagem = `Tem certeza que deseja apagar o documento?`;
        }
        if (!window.confirm(mensagem)) {
            return;
        }

        const dados = {
            id_comunicado: comunicado.id_comunicado,
        };
        let url = ApiEndpoints.comunicadoDeletarImagemDestaque;
        if (view === "documento") {
            url = ApiEndpoints.comunicadoDeletarDocumento;
        }
        setLoading(true);
        const api = await reqPatch(url, dados);
        setLoading(false);
        if (api.status === 200) {
            toast.success("Arquivo deletado com sucesso!", {
                containerId: 1,
                position: "top-center",
                theme: "dark",
            });
            handleUpdate();
            if (view === "imagem") { defineValueInInput("imagem", null) }
            if (view === "documento") { defineValueInInput("documento", null) }
        }
    }

    async function handleDownloadArquivo(view: "imagem" | "documento") {
        let url = ApiEndpoints.comunicadoDownloadImagem;
        let filename = `Imagem-Destaque-${comunicado.imagem_servidor}`;
        if (view === "documento") {
            url = ApiEndpoints.comunicadoDownloadDocumento;
            const documento = documentos[0];
            filename = documento.nome;
        }
        const dados = {
            id_comunicado: comunicado.id_comunicado,
        };
        setLoading(true);
        await reqPostDownloadFile(url, dados, filename);
        setLoading(false);
    }

    if (view === "documento") {
        if (documentos.length === 0) {
            return <div></div>;
        }
        let documento = documentos[0];
        return (
            <div>
                <div className="div-row">
                    <p style={{ width: "max-content", backgroundColor: "#DDDDDD", padding: "10px", marginRight: "10px" }}>{documento.nome}</p>
                    <Button disabled={loading} onClick={() => handleDownloadArquivo(view)} variant="outline-secondary" size="sm" style={{ marginRight: "10px" }}>
                        Download
                    </Button>
                    <Button disabled={loading} onClick={() => handleApagarArquivo(view)} variant="outline-secondary" size="sm" style={{ marginRight: "10px" }}>
                        Deletar
                    </Button>
                </div>
            </div>
        );
    }

    if (comunicado.imagem === null || comunicado.imagem_servidor === null) {
        return <div></div>;
    }
    return (
        <div>
            <div className="div-row">
                <p style={{ width: "max-content", backgroundColor: "#DDDDDD", padding: "10px", marginRight: "10px" }}>{comunicado.imagem_servidor}</p>
                <Button disabled={loading} onClick={() => handleDownloadArquivo(view)} variant="outline-secondary" size="sm" style={{ marginRight: "10px" }}>
                    Download
                </Button>
                <Button disabled={loading} onClick={() => handleApagarArquivo(view)} variant="outline-secondary" size="sm" style={{ marginRight: "10px" }}>
                    Deletar
                </Button>
            </div>
        </div>
    );
}
interface iProps {
    view: "imagem" | "documento";
    comunicado: any;
    documentos: any[];
    handleUpdate: any;
}
